import React from "react";
import { string, arrayOf, shape } from "prop-types";
import SubSectionHeading from "../../atoms/SubSectionHeading";
import SectionParagraph from "../../atoms/SectionParagraph";

import "./special-card.m.css";

const SpecialCard = ({ title, sections, ...props }) => {
  return (
    <div styleName="special-card" {...props}>
      <div styleName="header">
        <SubSectionHeading variant="dark">{title}</SubSectionHeading>
      </div>
      <div styleName="body">
        {sections?.map((section, index) => {
          const { title, content } = section || {};
          return (
            <div key={index} styleName="section">
              <SubSectionHeading>{title}</SubSectionHeading>
              <div styleName="content">
                <SectionParagraph>{content}</SectionParagraph>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

SpecialCard.propTypes = {
  title: string.isRequired,
  sections: arrayOf(shape({
    title: string.isRequired,
    content: string.isRequired
  })).isRequired
};

export default SpecialCard;